import { Button, Layout } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import PolicyService from '../../../services/Policy.service';
import { ROUTER } from '../../../constants/router';
import ListPrivacy from '../Shared/ListPrivacy';
import { useForm } from 'antd/lib/form/Form';
import DocTabs from './components/DocTabs';
import { useFreeFormtoString } from './components/PreviewtoString';
import { PlusOutlined } from '@ant-design/icons';
import GlobalService from '../../../services/Global.service';
import { calculateImageWidth } from '../../../util/util';
import usePermission from '../../../hooks/usePermission';

const FreeForm = ({ selectType }) => {
    const { t, i18n } = useTranslation(['translation', 'hr-policy']);
    let lang = i18n.language;
    const [data, setData] = useState([]);
    const [currentSelectList, setCurrentSelectList] = useState();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState();
    const [detailPublished, setDetailPublished] = useState();
    const [logo, setLogo] = useState('');
    const [logoPublish, setLogoPublish] = useState('');

    const getImage = async (companyLogoId) => {
        try {
            const { data } = await GlobalService.getImage(companyLogoId);
            if (data.resultData?.imageId) {
                return `data:image/png;base64,${data.resultData?.imageId}`;
            }
        } catch (error) {
            setLogo('');
            setLogoPublish('');
            console.log(error);
        }
    };

    useEffect(() => {
        // setDetail();
        // setDetailPublished();
        const getFreeForm = async () => {
            setLoading(true);
            try {
                const { data } = await PolicyService.getFreeForm(
                    currentSelectList?.freeFormPolicyNoticeId
                );
                if (data?.resultData) {
                    setDetail(data?.resultData);
                    setLoading(false);
                    // Logo
                    setLogo('');
                    if (
                        data?.resultData?.freeFormPolicy?.freeFormCompanyLogoId
                    ) {
                        getImage(
                            data?.resultData?.freeFormPolicy
                                ?.freeFormCompanyLogoId
                        ).then((logo) => setLogo(logo));
                    }
                }
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        };
        const getPublishedVersion = async () => {
            try {
                const { data } = await PolicyService.getFreeFormDetailPublic(
                    currentSelectList?.freeFormPolicyNoticeId
                );
                if (data?.resultData) {
                    const parse = JSON.parse(data?.resultData?.data);
                    setDetailPublished(parse);
                    // Logo
                    setLogoPublish('');
                    console.log(parse);
                    if (parse?.freeFormPolicy?.freeFormCompanyLogoId) {
                        getImage(
                            parse?.freeFormPolicy?.freeFormCompanyLogoId
                        ).then((logo) => setLogoPublish(logo));
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (currentSelectList?.freeFormPolicyNoticeId) getFreeForm();
        if (
            currentSelectList?.hasChanged &&
            currentSelectList?.status === 'Published'
        )
            getPublishedVersion();
        else setDetailPublished();
    }, [currentSelectList]);

    let navigate = useNavigate();

    const getPolicyList = async () => {
        const query = {
            dataSubjectTypeIds: selectType ? selectType : '',
        };
        const { data } = await PolicyService.getFreeFormList(query);
        if (data.resultData) {
            setData(data.resultData);
            setCurrentSelectList(data.resultData[0]);
        }
    };

    useEffect(() => {
        getPolicyList();
    }, [selectType]);

    const [form] = useForm();

    const width1 = calculateImageWidth(logo);
    const width2 = calculateImageWidth(logoPublish);

    const { html } = useFreeFormtoString(detail, 'th', logo, width1);
    const { html: htmlEn } = useFreeFormtoString(detail, 'en', logo, width1);

    const { html: htmlPublish } = useFreeFormtoString(
        detailPublished,
        'th',
        logoPublish,
        width2
    );
    const { html: htmlPublishEn } = useFreeFormtoString(
        detailPublished,
        'en',
        logoPublish,
        width2
    );

    const { isAuditor } = usePermission();

    return (
        <Layout>
            <div className="flex items-center my-4">
                <div className="flex-1 font-bold text-xl">
                    {t('policy.policy list')}
                </div>
                <Button
                    disabled={isAuditor}
                    type="primary"
                    size="large"
                    onClick={() => {
                        navigate(`${ROUTER.POLICY.FREE_FORM}/new#freeForm`);
                    }}
                    icon={<PlusOutlined />}
                >
                    {t('Add Policy')}
                </Button>
            </div>
            <div className="grid grid-cols-7 gap-4">
                <ListPrivacy
                    data={data}
                    pathEdit={ROUTER.POLICY.FREE_FORM}
                    stepEdit={''} // step preview
                    currentSelectName={{
                        nameTh: detail?.freeFormPolicy?.freeFormPolicyNameTh,
                        nameEn: detail?.freeFormPolicy?.freeFormPolicyNameEn,
                        namePublishTh:
                            detailPublished?.freeFormPolicy
                                ?.freeFormPolicyNameTh,
                        namePublishEn:
                            detailPublished?.freeFormPolicy
                                ?.freeFormPolicyNameEn,
                    }}
                    linkName="external-free-form"
                    getPolicyList={getPolicyList}
                    setCurrentSelectList={setCurrentSelectList}
                    currentSelectList={currentSelectList}
                    form={form}
                    // Parameters Name
                    policyObject={{
                        privacyName:
                            lang === 'en'
                                ? 'freeFormPolicyNoticeNameEn'
                                : 'freeFormPolicyNoticeNameTh',
                        nameTh: 'freeFormPolicyNoticeNameTh',
                        nameEn: 'freeFormPolicyNoticeNameEn',
                        privacyType:
                            lang === 'en'
                                ? 'freeFormPolicyTypeEn'
                                : 'freeFormPolicyTypeTh',
                        privacyId: 'freeFormPolicyNoticeId',
                        privacyCompany:
                            lang === 'en'
                                ? 'freeFormCompanyNameEn'
                                : 'freeFormCompanyNameTh',
                    }}
                    handelRename={(value) => {}}
                    historyObject={{
                        type: 'freeForm',
                        serviceHistory: PolicyService.getFreeFormHistories,
                        historyParamName: 'freeFormPolicyId', // ชื่อ payload ของ id ที่ service get history เช่น hrPrivacyPolicyId: "1234" ที่ต้องใส่คือ: hrPrivacyPolicyId
                        historyResultIdName: 'freeFormPolicyHistoryId', // ได้หลังจาก service get history ใน result ชื่อ parameter ของ id เช่น { "hrPrivacyPolicyHistoryId" : 1234 } ที่ต้องใส่คือ: hrPrivacyPolicyHistoryId
                    }}
                    deleteObject={{
                        serviceDelete: PolicyService.deleteFreeForm,
                        title: lang === 'en' ? 'Confirm Delete' : 'ยืนยันการลบ',
                        text:
                            currentSelectList?.status === 'Draft'
                                ? lang === 'en'
                                    ? `Do you want to delete draft version ${currentSelectList?.version} ?`
                                    : `คุณต้องการลบรายการแบบร่างเวอร์ชัน ${currentSelectList?.version} ?`
                                : lang === 'en'
                                ? `<span style='color:#F0536F'>The use of the URL link for this policy will still be available, but cannot be edited anymore.</span>\nDo you want to delete publish version ${currentSelectList?.latestPublishVersion} ?`
                                : `<span style='color:#F0536F'>การใช้งาน URL link นโยบายนี้จะยังคงใช้งานได้ แต่จะไม่สามารถแก้ไขนโยบายได้อีก</span>\nคุณต้องการลบรายการเผยแพร่เวอร์ชัน ${currentSelectList?.latestPublishVersion} ?`,
                    }}
                    // pop up ของ confirm ก่อน delete
                    confirmObject={{
                        title:
                            lang === 'en'
                                ? 'There may be websites that use this policy.'
                                : 'อาจมีเว็บไซต์ใช้นโยบายนี้อยู่',
                        text:
                            lang === 'en'
                                ? `Before deleting the data, please check that no website is using this policy.`
                                : `ก่อนลบข้อมูล โปรดตรวจสอบว่าไม่มีเว็บไซต์ใดใช้นโยบายนี้อยู่`,
                    }}
                    loading={loading}
                    templateBody={{ html, htmlEn, htmlPublish, htmlPublishEn }}
                >
                    {(previewLang) => (
                        <DocTabs
                            detailPublished={detailPublished}
                            detail={detail}
                            loading={loading}
                            currentSelectList={currentSelectList}
                            previewLang={previewLang}
                            freeFormPolicyId={
                                currentSelectList?.freeFormPolicyNoticeId
                            }
                            logo={logo}
                            logoPublish={logoPublish}
                        />
                    )}
                </ListPrivacy>
            </div>
        </Layout>
    );
};

export default FreeForm;
